/**
 * O link "Ver menções" de um upload (2026-10-26).
 *
 * A tela de menções lembra o filtro da empresa no navegador, e o
 * `?upload=` da URL sempre foi SOMADO a ele: quem chegava pelo detalhe do
 * upload via o upload filtrado por cima do período, dos subtemas e do que
 * mais tivesse ficado guardado — e achava que o upload tinha poucas
 * menções. Os links do upload agora levam `so_upload`, o sinal de que a
 * pessoa quer VER O UPLOAD: a rota de menções zera o filtro guardado e
 * tira o sinal da URL (ver `MentionsRoute`).
 *
 * Um F5 ou um link compartilhado só com `?upload=` não leva o sinal, de
 * propósito: não apagam o filtro de ninguém. Só o clique nestes links
 * troca o filtro.
 */

/** O parâmetro que pede "só o upload". Consumido pela rota de menções. */
export const ONLY_UPLOAD_PARAM = "so_upload";

/** Quem monta o destino dos links que levam às menções de um upload —
 *  um dono só, pra o sinal nunca ficar de fora de um deles. */
export function uploadMentionsHref(companyId: string, uploadId: number): string {
  return `/empresas/${companyId}/mencoes?upload=${uploadId}&${ONLY_UPLOAD_PARAM}=1`;
}
